export const styles = {
  listTwoColumn: {
    columns: { xs: 1, sm: 2 },
  },
} as const;
